import {Loader} from "@googlemaps/js-api-loader";

export default {
    init() {
        this.saveEvent('save-event-form');
        this.editEventModal('event__table-box-edit');
        $('.modal-event__body-wrapper-box-start').datetimepicker({
            format: 'MM/DD/YYYY hh:mm a',
            minDate: 0,
            locale: 'en',

        });
        $('.modal-event__body-wrapper-box-end').datetimepicker({
            format: 'MM/DD/YYYY hh:mm a',
            minDate: 0,
            locale: 'en',
        });
        $('.modal-event__body-wrapper-box-published').datetimepicker({
            format: 'MM/DD/YYYY hh:mm a',
            minDate: 0,
            locale: 'en',
        });
        this.showEvent('event__table-box-show');
        this.mapInit();
        this.saveUrlImage();
        this.loader_lib = false;

    },

    saveEvent(id = '') {
        $('#' + id).submit(function(e){
            e.preventDefault();
            let form = $(this);

            $.ajax({
                url: form.attr('action'),
                method: form.attr('method'),
                data: form.serialize(),
                success: function(response){
                    window.location.reload();
                },
                error: function(response){

                    if (response.status == '422')
                    {
                        $('.modal-event__body-wrapper-errors').html('');
                        for (let errorKey in response.responseJSON.errors) {
                           $('.modal-event__body-wrapper-errors').append('<div style="margin-bottom: 5px;">' + response.responseJSON.errors[errorKey] + '</div>');
                        }
                        $('.modal-event__body-wrapper-errors').removeClass('d-none');
                    }

                }
            })
        });
    },

    editEventModal(event = ''){
        let _this = this;
        $('.' + event).click(function (e){
            let element = $(this);
            let eventId = element.data('event-id');
            $.ajax({
                url: '/admin/event-management/get-edit-event/' + eventId,
                method: 'GET',
                success: function(res) {
                    $('#ajax_modals_container').html(res);
                    $('#edit-event').modal('show');
                    _this.saveEvent('edit-save-event-form');
                    $('.modal-event__body-wrapper-box-start').datetimepicker({
                        format: 'MM/DD/YYYY hh:mm a',
                        minDate: 0,
                        locale: 'en',
                    });
                    $('.modal-event__body-wrapper-box-end').datetimepicker({
                        format: 'MM/DD/YYYY hh:mm a',
                        minDate: 0,
                        locale: 'en',
                    });
                    $('.modal-event__body-wrapper-box-published').datetimepicker({
                        format: 'MM/DD/YYYY hh:mm a',
                        minDate: 0,
                        locale: 'en',
                    });
                    _this.saveUrlImage();
                },
                error: function(response){

                    if (response.status == '422')
                    {
                        $('.modal-event__body-wrapper-errors').html('');
                        for (let errorKey in response.responseJSON.errors) {
                            console.log(response.responseJSON.errors);
                            $('.modal-event__body-wrapper-errors').append('<div style="margin-bottom: 5px;">' + response.responseJSON.errors[errorKey] + '</div>');
                        }

                        $('.modal-event__body-wrapper-errors').removeClass('d-none');
                    }

                }
            });
        });
    },

    showEvent(id = ''){
        let _this = this;
        $('.' + id).click(function (e){
            let element = $(this);
            let eventId = element.data('event-id');
            $.ajax({
                url: '/admin/event-management/get-show-event/' + eventId,
                method: 'GET',
                success: function(res) {
                    $('#ajax_modals_container').html(res);
                    $('#show-event').modal('show');
                }
            });
        });
    },

    mapInit(){
        //console.log('initmap', this.checkCurrentPath(), window.location.pathname);
        if (this.checkCurrentPath()) {
            if($('meta[name="google-api-key"]').length){
                let _this = this;
                let googlApi = $('meta[name="google-api-key"]').attr('content');
                const apiOptions = {
                    apiKey: googlApi
                };
                const loader = new Loader(apiOptions);
                loader.load().then(() => {
                    let element = $('#event-route-map');
                    let lat = parseFloat(element.data('event-lat'));
                    let lon = parseFloat(element.data('event-lon'));
                    this.RouteDisplayMap({
                        lat,
                        lon,
                    });
                });
                /* let loader;
                import('@googlemaps/js-api-loader').then((module)=>{
                    this.loader_lib = module.Loader;
                }).then(()=>{
                    loader = new this.loader_lib(apiOptions)
                }).then(() => {
                    loader.load().then(() => {
                        let element = $('#event-route-map');
                        let lat = parseFloat(element.data('event-lat'));
                        let lon = parseFloat(element.data('event-lon'));
                        this.RouteDisplayMap({
                            lat,
                            lon,
                        });
                        console.log(google);
                    });
                }); */
            }
        }
    },

    checkCurrentPath(){
        let currentPath = window.location.pathname;
        const pathesArray = [
            '/worker-cabinet',
            '/customers',
            '/appointments',
            '/jobs-flow',
            '/events'
        ];
        let flag = false;
        pathesArray.forEach(element => {
            if (currentPath == element) {
                flag = true;
            }else if(currentPath.includes(element)){
                flag = true;
            }
        });
        return flag;
    },

    RouteDisplayMap(latLonObj) {
        let _this = this;
        let route_map_center = new google.maps.LatLng(latLonObj.lat, latLonObj.lon);
        //let mapCanvas = document.getElementById('event-route-map');
        //console.log(document.querySelector('div.googleMaps'));
        let mapOptions = {
            zoom: 17,
            center: route_map_center,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: false,
            scrollwheel: true,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: true,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            clickableIcons: false,
            styles: [{"featureType": "administrative", "elementType": "geometry", "stylers": [{"visibility": "off"}]},
                {"featureType": "poi", "stylers": [{"visibility": "off"}]},
                {"featureType": "road", "elementType": "labels.icon", "stylers": [{"visibility": "off"}]},
                {"featureType": "transit", "stylers": [{"visibility": "off"}]}]
        };
        let mapsElements = document.querySelectorAll('div.googleMaps');
        mapsElements.forEach((elem) => {
            let route_map = new google.maps.Map(elem, mapOptions);
            _this.RouteMapAddMarkerOrder(latLonObj, route_map);
        });

    },

    RouteMapAddMarkerOrder(latLonObj, map){

        let marker = new google.maps.Marker({
            position: {
                lat: latLonObj.lat,
                lng: latLonObj.lon,
            },
            animation: '',
            map: map,
        });
    },

    saveUrlImage (){
        $('.modal-event__body-wrapper-img').blur(function (e){
            let matches = $(this).val().match('\/([A-Za-z0-9() _\\-\\.]+)$');
            if(matches != null){
                $(this).val(matches[1]);
            }else{
                /*$(this).val('');*/
            }
        });
    }



}
